import React, { Component } from "react";
import { Link, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import { isMobileOnly } from "react-device-detect";
import { Header, SmartphoneHeader } from "ui/components";

import "uikit";

import { Page, Container } from "ui/elements";
import { TestDriveModal, ContactsModal } from "ui/components";
import { fetch } from "store/notices/actions";

class HomePage extends Component {
  componentDidMount() {
    this.props.dispatch(fetch());
  }

  render() {
    return (
      <Page title="Home" className="home">
        <main>
          <Container>
            {isMobileOnly ? (
              <SmartphoneHeader notice={this.props.notice} />
            ) : (
              <Header notice={this.props.notice} />
            )}

            <section id="news">
              <h3>
                Avviso: hai scaricato la nuova App?{" "}
                <Link to="/avvisi">Scopri di più...</Link>
              </h3>
            </section>

            <section id="services">
              <h2>I nostri servizi</h2>

              <div className="uk-grid uk-grid-large uk-child-width-1-2@s uk-child-width-1-3@m">
                <div>
                  <h3>Sala attrezzi</h3>
                  <p>
                    Attrezzatura Technogym e staff tecnico certificato SNPT.
                    L’assistenza di sala ed i programmi di allenamento sono
                    gratuiti.
                  </p>
                </div>

                <div>
                  <h3>Sala corsi</h3>
                  <p>
                    Corsi di Mat Pilates, Functional Training, Yoga, Bodyweight,
                    Postural... e molto altro, compresi in tutti gli
                    abbonamenti.
                  </p>
                </div>

                <div>
                  <h3>Area funzionale</h3>
                  <p>
                    Area attrezzata con Cross Rig, bilancieri olimpionici,
                    kettlebell, TRX®, wall ball, BOSU® e pavimento antitrauma.
                  </p>
                </div>

                <div>
                  <h3>Sauna</h3>
                  <p>
                    La sauna finlandese favorisce l’eliminazione delle tossine e
                    dei liquidi in eccesso, ha effetti benefici sulla
                    muscolatura e aiuta a combattere lo stress.
                  </p>
                </div>

                <div>
                  <h3>Estetica e Osteopatia</h3>
                  <p>
                    All'interno del club sono presenti un centro estetico e uno
                    studio medico dove è possibile prenotare trattamenti
                    osteopatici terapeutici.
                  </p>
                </div>

                <div>
                  <h3>Visita medica</h3>
                  <p>
                    Visita medica direttamente in sede, completa di
                    elettrocardiogramma, con rilascio di certificato di idoneità
                    all’attività sportiva non agonistica.
                  </p>
                </div>
              </div>
            </section>

            <section id="planning">
              <div className="uk-grid">
                <div className="uk-width-1-2@s">
                  <p className="uk-text-center">
                    <i className="fa fa-calendar fa-3x" />
                  </p>

                  <a href="/planning-corsi.pdf">
                    Scarica il planning dei corsi
                  </a>
                </div>

                <div className="uk-width-1-2@s">
                  <p className="uk-text-center">
                    <i className="fa fa-smile-o fa-3x" />
                  </p>

                  <Link to="/prenota-una-prova-gratuita">
                    Prenota una prova gratuita
                  </Link>
                </div>
              </div>
            </section>

            <section id="combat">
              <div className="combat-bovisa-logo">
                <div className="uk-grid uk-flex-center">
                  <div className="uk-width-2-5@m uk-width-1-2@s">
                    <img
                      className="uk-width-1-1"
                      src="/assets/images/combat/logo-combat-bovisa.png"
                      alt="Combat Bovisa"
                    />
                  </div>
                </div>
              </div>

              <div className="uk-background-cover uk-flex uk-flex-center uk-flex-middle uk-panel title-container">
                <div className="logos-wrapper">
                  <div className="uk-grid uk-margin-remove-top uk-child-width-1-6@m uk-child-width-1-4@s uk-child-width-1-2 uk-flex-center disciplines">
                    <div>
                      <img
                        className="uk-width-1-1"
                        src="/assets/images/combat/logo-pugilato.png"
                        alt="Combat Bovisa - Pugilato"
                      />
                    </div>
                    <div>
                      <img
                        className="uk-width-1-1"
                        src="/assets/images/combat/logo-karate.png"
                        alt="Combat Bovisa - Karate"
                      />
                    </div>
                    <div>
                      <img
                        className="uk-width-1-1"
                        src="/assets/images/combat/logo-muay-thai.png"
                        alt="Combat Bovisa - Muay Thai"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="intro">
                <p>
                  200mq dedicati agli sport da combattimento, attrezzati con
                  ring, tatami antitrauma e sacchi da allenamento.
                </p>
              </div>

              <div className="wrapper">
                <div className="uk-grid uk-grid-medium uk-child-width-1-1@m">
                  <div>
                    <img
                      className="uk-width-1-1"
                      src="/assets/images/combat/pugilato.jpg"
                      alt="Area Combat - Pugilato"
                    />
                    <h3>Pugilato</h3>
                    <p className="instructor">
                      <strong>Istruttore: Giancarlo Cappellano</strong>
                      <br />
                      Tecnico della Federazione Pugilistica Italiana
                    </p>
                    <hr />
                    <p className="description">
                      La nobile arte del Pugilato è un'eccellente tecnica di
                      combattimento che sviluppa la resistenza aerobica, la
                      velocità e la forza esplosiva dell'atleta, oltre alle
                      capacità tecnico-tattiche.
                    </p>
                    <div className="plannings">
                      <div className="planning uk-grid uk-grid-small uk-margin-remove-top">
                        <div className="uk-width-1-1">
                          <span className="discipline">
                            Junior <small>(6-13 anni)</small>
                          </span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="days">lunedì e mercoledì</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="hours">17:00 (1h)</span>
                        </div>
                      </div>
                      <div className="planning uk-grid uk-grid-small uk-margin-remove-top">
                        <div className="uk-width-1-1">
                          <span className="discipline">Adulti</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="days">lunedì</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="hours">
                            13:00 (1h 15m), 18:00 (1h 15m) &nbsp;e&nbsp; 19:15
                            (1h 30m)
                          </span>
                        </div>
                      </div>
                      <div className="planning uk-grid uk-grid-small uk-margin-remove-top">
                        <div className="uk-width-1-1">
                          <span className="days">mercoledì</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="hours">
                            13:00 (1h 15m), 18:00 (1h 15m), 19:15 (1h 30m)
                            &nbsp;e&nbsp; 20:45 (1h 30m)
                          </span>
                        </div>
                      </div>
                      <div className="planning uk-grid uk-grid-small uk-margin-remove-top">
                        <div className="uk-width-1-1">
                          <span className="days">venerdì</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="hours">
                            13:00 (1h 15m), 18:00 (1h 15m), 19:15 (1h 30m)
                            &nbsp;e&nbsp; 20:45 (1h 30m)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <img
                      className="uk-width-1-1"
                      src="/assets/images/combat/karate.jpg"
                      alt="Area Combat - Karate Shotokan"
                    />
                    <h3>Karate Shotokan</h3>
                    <p className="instructor">
                      <strong>Istruttore: M° Domenico Borrello</strong>
                      <br />
                      Cintura nera 6° dan
                    </p>
                    <hr />
                    <p className="description">
                      Il Karate è un'arte marziale giapponese nata come
                      strumento di difesa personale a mani nude. Lo stile
                      Shotokan prevede lo studio dei fondamentali (kihon), delle
                      forme (kata) e la pratica del combattimento (kumite).
                    </p>
                    <div className="plannings">
                      <div className="planning uk-grid uk-grid-small uk-margin-remove-top">
                        <div className="uk-width-1-1">
                          <span className="discipline">
                            Junior <small>(dai 6 anni)</small>
                          </span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="days">martedì e giovedì</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="hours">17:00 (1h)</span>
                        </div>
                      </div>
                      <div className="planning uk-grid uk-grid-small uk-margin-remove-top">
                        <div className="uk-width-1-1">
                          <span className="discipline">Adulti</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="days">martedì e giovedì</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="hours">19:00 (1h 45m)</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <img
                      className="uk-width-1-1"
                      src="/assets/images/combat/muay-thai.jpg"
                      alt="Area Combat - Muay Thai"
                    />
                    <h3>Muay Thai</h3>
                    <p className="instructor">
                      <strong>Istruttore: Simone Cussigh</strong>
                      <br />
                      Oltre 20 anni di esperienza nell'insegnamento
                    </p>
                    <hr />
                    <p className="description">
                      La Muay Thai è un'arte marziale derivata dall'antica
                      tecnica di lotta thailandese, che utilizza come punti di
                      contatto nel combattimento le mani, i piedi, le ginocchia
                      e i gomiti.
                    </p>
                    <div className="plannings">
                      <div className="planning uk-grid uk-grid-small uk-margin-remove-top">
                        <div className="uk-width-1-1">
                          <span className="discipline">Adulti</span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="days">
                            lunedì, martedì e giovedì
                          </span>
                        </div>
                        <div className="uk-width-1-1">
                          <span className="hours">20:45 (1h 30m)</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="map">
              <h2>Dove siamo</h2>
              <img
                className="uk-width-1-1"
                src="/assets/images/mappa.jpg"
                alt="Via Ugoni 15, 20158 Milano Bovisa"
              />
            </section>

            <img
              id="altea"
              className="uk-width-1-1"
              src="/assets/images/banner-altea.png"
              alt="Altea"
            />

            <section id="call-now">
              <a href="tel:0280886302">Chiama ora</a>
            </section>

            <footer>
              <p className="uk-text-center">
                &copy; {new Date().getFullYear()} Youcan srl ssd. Tutti i
                diritti riservati &mdash; P.IVA 06398320967 &mdash; Tel.
                02.80.88.63.02 &mdash; E-mail: info@youcanfitnessfactory.it
              </p>
              <p className="uk-text-center">
                <Link to="/privacy-policy">Privacy Policy</Link>
              </p>
            </footer>

            <Switch>
              <Route
                exact
                path="/prenota-una-prova-gratuita"
                component={TestDriveModal}
              />
              <Route exact path="/contatti" component={ContactsModal} />
            </Switch>
          </Container>
        </main>
      </Page>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.notices,
});

export default connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/ui/pages/HomePage.js